import './RichTextBubble.css';
import React from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
const RichTextBubble = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const textValue = get(fields, 'text.value', '');
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `row`,
    style: textValue ? {} : {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    className: "rich-text",
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper rich-text__inner",
    dangerouslySetInnerHTML: {
      __html: textValue
    }
  })))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
const commonStyles = "cldlv36";
const ltrStyles = "l1cuqpwr";
const rtlStyles = "rbpwbrr";
export default RichTextBubble;